import { passkeyClient } from '@better-auth/passkey/client'
import { emailOTPClient, twoFactorClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/vue'

const baseURL = import.meta.env.VITE_AUTH_URL ?? '/auth'

export const authClient = createAuthClient({
  baseURL,
  plugins: [emailOTPClient(), passkeyClient(), twoFactorClient()],
  fetchOptions: { credentials: 'include' },
})

export type AuthClient = typeof authClient
